import {Injectable} from '@angular/core';
import {ApiService} from "../api.service";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {OfferPeriod} from '@core/shared/models/offer/offer-period';

@Injectable({
    providedIn: 'root'
})
export class OfferPriceLevelService {

    constructor(
        private _apiService: ApiService,
        private _httpClient: HttpClient
    ) {}

    public updateOfferItemsAPI(id: number, data: object): Observable<OfferPeriod> {

        const url = `${this._apiService.getApiUrl(false, true)}/offers/${id}/priceLevels`;

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'text')
            .set('Accept', 'application/json');

        return this._httpClient.patch<OfferPeriod>(url, data, {
            headers: headers
        });
    }
}

